import { LeafletMouseEvent } from 'leaflet';
import React from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import { DropLocationActiveIcon } from 'views/RoutePlanner/components/DropLocationActive';
import { DropLocationIcon } from 'views/RoutePlanner/components/DropLocationIcon';

const ClickableMarkerForHomes = props => {
  return (
    <Marker
      draggable={true}
      position={[
        props.address?.address_latitude,
        props.address?.address_longitude
      ]}
      icon={
        props.address?.enabled === true
          ? DropLocationActiveIcon
          : DropLocationIcon
      }
      eventHandlers={{
        click: () => {
          props.setSelectedAddress(props.address);
          props.handleConfirm(props.address, !props.address?.enabled);
        },
        contextmenu: (event: LeafletMouseEvent) => {
          event.originalEvent.preventDefault();
          props.handleMarkerClicked(props.address);
        },
        dragend: e => {
          const marker = e.target;
          const { lat, lng } = marker.getLatLng();

          const shouldProceed = window.confirm(`Are you sure you want to change the coordinates for ${props.address?.address}`)
          if (shouldProceed) {
            props.handleChangeCoords(lat, lng);
          } else {
            marker.setLatLng([props.address?.address_latitude, props.address?.address_longitude]);
          }
        }
      }}>
      <Tooltip>{props.address?.address}</Tooltip>
    </Marker>
  );
};

export default React.memo(ClickableMarkerForHomes);
